module.exports = __webpack_public_path__ + "img/logo_sp.8bee00ee.svg";